<template>
  <div
    class="inline-block animate-spin rounded-full border-2 border-current border-r-transparent"
    :style="{ width: `${size}px`, height: `${size}px` }"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), { size: 24 })
</script>
